import type { PartnerHead } from "../shared/partnerHead";
import { asset } from "./assets";
import { HOSTEL_INDEX, MAP_HOSTEL_SLUGS, ROUTE_INDEX } from "./routeIndex";

/**
 * Titles and descriptions of the three Mad Monkey routes, and which route ids and hostel slugs exist.
 * Used by the route table (marketingRoutes.tsx, in the entry bundle, hence the light `routeIndex`) and by the
 * page, which sets the title again when the visitor moves between them without a page load.
 * No em dashes: they are new titles.
 */

const SUFFIX = "Stippl × Mad Monkey";

export const HOME_HEAD: PartnerHead = {
	title: `${SUFFIX}: build your Southeast Asia route`,
	description: "23 Mad Monkey hostels in six countries and a free planner to string them together. Build your own route or start from a ready-made one.",
	ogImage: asset("photos/koh-rong-0.jpg"),
};

export const isKnownRoute = (id: string): boolean => ROUTE_INDEX.some((t) => t.id === id);

export const isKnownHostel = (slug: string): boolean => HOSTEL_INDEX.some((h) => h.slug === slug);

export function routeHead(id: string): PartnerHead | null {
	const t = ROUTE_INDEX.find((r) => r.id === id);
	return t ? { title: `${t.name} | ${SUFFIX}`, description: t.blurb, ogImage: asset(`photos/${t.first}-0.jpg`) } : null;
}

export function hostelHead(slug: string): PartnerHead | null {
	const h = HOSTEL_INDEX.find((x) => x.slug === slug);
	return h
		? {
				title: `Mad Monkey ${h.name} | ${SUFFIX}`,
				description: `Mad Monkey ${h.name}: photos, what's on, things to do nearby and how to add it to your Stippl route.`,
				ogImage: asset(`photos/${slug}-0.jpg`),
			}
		: null;
}

/**
 * The head of a hostel's map page, `/p/mad-monkey-<hostel>` (`partners/maps/headIndex.ts` asks for it by the hostel's slug):
 * the hostel's first photo is its card. Null for a hostel that has no map.
 */
export function mapHead(slug: string): PartnerHead | null {
	const h = MAP_HOSTEL_SLUGS.includes(slug) ? HOSTEL_INDEX.find((x) => x.slug === slug) : undefined;
	return h
		? {
				title: `${SUFFIX} ${h.name}: map and week program`,
				description: `The crew's picks around Mad Monkey ${h.name} and what is on at the hostel this week, on the free Stippl map.`,
				ogImage: asset(`photos/${slug}-0.jpg`),
			}
		: null;
}
